export default __webpack_public_path__ + "static/media/bg-bottom-right.68165af6.svg";